import { registerSystemAdminTab } from "routes/sfg20-admin/plugins/system-tab/register-system-admin-tab"
import { PRIORITY_ACCESS, SECTION_ACCESS } from "routes/sfg20-admin/plugins/system-tab/system-admin-sections"
import { hasDemand } from "lib/authorization/has-demand"
import { SSOEstatePanel } from "routes/system-admin/sso-overview/sso-estate-panel"

// Registered as a page in the System Admin application (/system-admin/identity-providers) under
// the Access section, alongside Auth Bundles and Bundle/Demand Use. The route and the nav item
// share the predicate below, so this file needs no edit to the host application.
//
// The System Admin app is already behind DemandGuard demands={["admin"]}, but the predicate is
// repeated here on purpose: this page is the cross-tenant domain → client index, and it must be
// impossible to surface it by mounting the panel from anywhere else. `admin`, never `clientAdmin`.
function isSystemAdmin() {
    return hasDemand("admin")
}

registerSystemAdminTab(
    "Identity Providers",
    <SSOEstatePanel $lazy />,
    isSystemAdmin,
    PRIORITY_ACCESS + 20,
    "mdi:shield-account-outline",
    SECTION_ACCESS
)
